import API from '@config/api';

const login = creds => API.post('/auth', creds);
const registration = creds => API.post('/auth/register', creds);

export {login, registration};
